/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from "react";

import {
  Button,
  Col,
  Dropdown,
  Menu,
  Row,
  message,
  Input,
  Modal,
  Form,
} from "antd";

import logo_footer from "../images/design/logoFooter.svg";
import logo_Final from "../images/design/logoHeader.svg";
import FormItem from "antd/lib/form/FormItem";
import LandingPageSearch from "./LandingPageSearch";
import {
  FacebookOutlined,
  TwitterOutlined,
  SearchOutlined,
  PicLeftOutlined,
  CloseCircleOutlined,
  // MailOutlined,
  // LockOutlined,
} from "@ant-design/icons";
import SignUp from "../components/SignUp";
import ForgotPass from "../components/ForgotPass";
import { login } from "../actions/member";
import { connect } from "react-redux";
import { colors } from "../constants/colors";
import EyeClosed from "../images/eyeClosedIcon.svg";
import EyeOpen from "../images/eyeOpenIcon.svg";
class LandingPageDesignMobile extends Component {
  lastFetchIdMobile = 0;
  startMyTeledoc = "";
  state = {
    isShowPanel: false,
    isShowPanelForDoctor: false,
    isdisplayShopPlansContent: false,
    statecard: "",
    dataNewMobile: [],
    valueSearchNewsMobile: [],
    fetchingNewMobile: false,
    isCheckReCapchaCheckbox: false,
    isClickCheckReCapchaCheckbox: false,
    titleModalFindDoctorLocation: "",
    visibleModalSignIn: false,
    isShowPanelSearchNews: false,
    isCollapseCoronapanel: false,
    fetchInputMyTeledoc: false,
    visibleSignUp: false,
    visibleForgot: false,
  };

  onChangeCollapse(val) {
    console.log("collapse:", val);
  }
  showModalSignIn = () => {
    this.setState({
      visibleModalSignIn: true,
    });
  };

  handleOkSignIn = (e) => {
    console.log(e);
    this.setState({
      visibleModalSignIn: false,
    });
  };

  handleCancelSignIn = (e) => {
    this.setState({
      visibleModalSignIn: false,
    });
  };

  handleSubmit(values) {
    const { login } = this.props;
    login(values).then((result) => {
      const { isSuccess, err } = result;

      if (isSuccess) {
        this.props.history.push("/manage/circle-user");
      } else {
        message.warn(err.message);
      }
    });
  }

  handleShowModal(name, value) {
    this.setState({
      [name]: value,
    });
  }

  handleResgiterSuccess() {
    this.handleShowModal("visibleSignUp", false);

    message.success("You have been register account success !");
    this.props.history.push("/manage/circle-user");
  }

  handleForgotPassSuccess() {
    this.handleShowModal("visibleForgot", false);
    message.success(
      "You have been reset account success, please check your email !"
    );
  }

  render() {
    const menu = (
      <Menu>
        {/* <Menu.Item key="0">
          <a href="#WelcometoGenCIDMobile">About</a>
        </Menu.Item>
        <Menu.Item key="1">
          <a href="#ForDoctorIDMobile">AM Store</a>
        </Menu.Item> */}
        <Menu.Item key="1">
          <a onClick={this.showModalSignIn} href="#ForDoctorIDMobile">
            Sign In
          </a>
        </Menu.Item>
        <Menu.Item key="2">
          <a
            onClick={(e) => {
              e.preventDefault();
              this.props.history.push("/how-it-works");
            }}
            href="/how-it-works"
          >
            How It Works
          </a>
        </Menu.Item>
        <Menu.Item key="3">
          <a
            onClick={(e) => {
              e.preventDefault();
              this.props.history.push("/our-team");
            }}
            href="/our-team"
          >
            Our Team
          </a>
        </Menu.Item>
        <Menu.Item key="4">
          <a
            onClick={(e) => {
              e.preventDefault();
              this.props.history.push("/contact-us");
            }}
            href="/contact-us"
          >
            Contact Us
          </a>
        </Menu.Item>
      </Menu>
    );
    const { Children } = this.props;
    const { visibleForgot, visibleSignUp } = this.state;
    return (
      <>
        <Row className="viewPort">
          <Col
            xs={{ span: 24 }}
            sm={{ span: 0 }}
            md={{ span: 0 }}
            lg={{ span: 0 }}
            xl={{ span: 0 }}
            xxl={{ span: 0 }}
            style={{ margin: 0, padding: "0px" }}
            className="frontUIMobileClass"
          >
            <Row
              style={{
                zIndex: "10000",
                top: 0,
                left: 0,
                position: "sticky",
                alignItems: "center",
                margin: 0,
                width: "100%",
                backgroundColor: colors.gencWhite,
              }}
            >
              <Col
                xs={{ span: 12 }}
                sm={{ span: 0 }}
                md={{ span: 0 }}
                lg={{ span: 0 }}
                xl={{ span: 0 }}
                xxl={{ span: 0 }}
                style={{ textAlign: "center", margin: 0, padding: 10 }}
              >
                <a href="/">
                  <img
                    alt="img"
                    shape="square"
                    style={{ width: "100%" }}
                    src={logo_Final}
                  />
                </a>
              </Col>
              <Col
                xs={{ span: 12 }}
                sm={{ span: 0 }}
                md={{ span: 0 }}
                lg={{ span: 0 }}
                xl={{ span: 0 }}
                xxl={{ span: 0 }}
                style={{ textAlign: "right", margin: 0, padding: 5 }}
              >
                <Button
                  onClick={() =>
                    this.setState({
                      isShowPanelSearchNews: !this.state.isShowPanelSearchNews,
                    })
                  }
                  type="link"
                  shape="round"
                  icon={
                    this.state.isShowPanelSearchNews ? (
                      <CloseCircleOutlined style={{ color: colors.gencRed }} />
                    ) : (
                      <SearchOutlined style={{ color: colors.gencRed }} />
                    )
                  }
                  style={{ padding: 5 }}
                />
                <Dropdown overlay={menu}>
                  <Button
                    type="link"
                    shape="round"
                    icon={<PicLeftOutlined style={{ color: colors.gencRed }} />}
                    style={{ padding: 5 }}
                  />
                </Dropdown>
              </Col>
              {this.state.isShowPanelSearchNews ? (
                <Col
                  xs={{ span: 24 }}
                  sm={{ span: 0 }}
                  md={{ span: 0 }}
                  lg={{ span: 0 }}
                  xl={{ span: 0 }}
                  xxl={{ span: 0 }}
                  style={{ margin: 0 }}
                >
                  <LandingPageSearch />
                </Col>
              ) : null}
            </Row>

            {/* content */}

            <Children {...this.props} />
            <Row
              style={{
                backgroundColor: colors.gencBlue,
                width: "100%",
                padding: "10vh 1em",
                paddingBottom: 0,
              }}
            >
              <Col
                xs={{ span: 24 }}
                sm={{ span: 24 }}
                md={{ span: 24 }}
                lg={{ span: 24 }}
                xl={{ span: 24 }}
                xxl={{ span: 24 }}
                style={{
                  margin: 0,
                  textAlign: "center",
                  padding: 0,
                  paddingBottom: 20,
                }}
              >
                <img alt="img" src={logo_footer} style={{ width: "100%" }} />
              </Col>
              <Col
                xs={{ span: 24 }}
                sm={{ span: 24 }}
                md={{ span: 24 }}
                lg={{ span: 24 }}
                xl={{ span: 24 }}
                xxl={{ span: 24 }}
                style={{ margin: 0 }}
              >
                <h4 style={{ color: "#fff", width: "100%" }}>Platform</h4>
                <p style={{ width: "100%", margin: 0 }}>
                  <a
                    href="#ForDoctorIDMobile"
                    style={{ fontSize: 16, color: colors.gencLightBlue }}
                  >
                    GenC Health-Box
                  </a>
                </p>
                <p style={{ width: "100%" }}>
                  <a
                    href="#WelcometoGenCIDMobile"
                    style={{ fontSize: 16, color: colors.gencLightBlue }}
                  >
                    AM Health Store
                  </a>
                </p>
              </Col>
              <Col
                xs={{ span: 24 }}
                sm={{ span: 24 }}
                md={{ span: 24 }}
                lg={{ span: 24 }}
                xl={{ span: 24 }}
                xxl={{ span: 24 }}
                style={{ margin: 0 }}
              >
                <h4 style={{ color: "#fff", width: "100%" }}>Subscribe</h4>
                <p style={{ width: "100%", margin: 0 }}>
                  <a
                    href="#AboutUsIDMobile"
                    style={{ fontSize: 16, color: colors.gencLightBlue }}
                  >
                    Product updates
                  </a>
                </p>
                <p style={{ width: "100%", margin: 0 }}>
                  <a
                    href="#WhileTravelingIDMobile"
                    style={{ fontSize: 16, color: colors.gencLightBlue }}
                  >
                    Company updates
                  </a>
                </p>
                <p style={{ width: "100%" }}>
                  <a
                    href="#BeforTravelingIDMobile"
                    style={{ fontSize: 16, color: colors.gencLightBlue }}
                  >
                    Trainings and jobs
                  </a>
                </p>
              </Col>
              <Col
                xs={{ span: 24 }}
                sm={{ span: 24 }}
                md={{ span: 24 }}
                lg={{ span: 24 }}
                xl={{ span: 24 }}
                xxl={{ span: 24 }}
                style={{ margin: 0 }}
              >
                <h4 style={{ color: "#fff", width: "100%" }}>Follow us</h4>
                <p style={{ width: "100%" }}>
                  <a
                    href="#BeforTravelingIDMobile"
                    style={{ fontSize: 16, color: colors.gencLightBlue }}
                  >
                    GenC Snacks
                  </a>
                </p>
                <a
                  href="https://www.facebook.com/genchealth/"
                  tarGet="_blank"
                  title="Facebook"
                  style={{ fontSize: 30, color: colors.facebookBlue }}
                >
                  <FacebookOutlined />
                </a>
                &nbsp;&nbsp;
                <a
                  href="https://twitter.com/GenCLabs"
                  tarGet="_blank"
                  title="Twitter"
                  style={{ fontSize: 30, color: colors.twitterBlue }}
                >
                  <TwitterOutlined />
                </a>
              </Col>
              <Row
                style={{
                  width: "100%",
                  justifyContent: "left",
                  color: "#fff",
                  fontSize: 18,
                  padding: 20,
                  borderTop: `2px solid ${colors.gencLightBlue}`,
                  marginTop: "2em",
                }}
              >
                <span>
                  {" "}
                  © Copyright 2020 GenC Labs, Inc. All rights reserved.
                </span>
              </Row>
            </Row>
          </Col>
        </Row>
        <Modal
          // title="Login to Your GenC Space"
          visible={this.state.visibleModalSignIn}
          onOk={this.handleOkSignIn}
          onCancel={this.handleCancelSignIn}
          footer={null}
          className="modalSignInClass"
        >
          <Form
            onFinish={(values) => {
              this.handleSubmit(values);
            }}
            layout="inline"
            className="formSignInClass"
            style={{ width: "100%" }}
          >
            <div className="text-center" style={{ margin: 0 }}>
              <h4 style={{ color: colors.gencBlue }}>
                Sign in to your GenC Space
              </h4>
              <p style={{ fontSize: "16px", color: "#221F1F" }}>
                Enter your email address and password
              </p>
            </div>
            <FormItem
              name="email"
              rules={[
                {
                  type: "email",
                  message: "The input is not valid E-mail!",
                },
                {
                  required: true,
                  message: "Please input your E-mail!",
                },
              ]}
              label={
                <label
                  style={{
                    color: colors.gencGrey,
                    fontSize: "16px",
                    fontWeight: "400",
                    margin: 0,
                  }}
                >
                  Email
                </label>
              }
              style={{ width: "100%" }}
            >
              <Input
                size="large"
                placeholder="Email"
                // prefix={<MailOutlined />}
              />
            </FormItem>
            <FormItem
              name="password"
              rules={[
                {
                  required: true,
                  message: "Please input your password!",
                },
              ]}
              label={
                <label
                  style={{
                    color: colors.gencGrey,
                    fontSize: "16px",
                    fontWeight: "400",
                    margin: 0,
                  }}
                >
                  Password
                </label>
              }
              style={{ width: "100%" }}
            >
              <Input.Password
                size="large"
                placeholder="Password"
                iconRender={(visible) =>
                  visible ? (
                    <img src={EyeOpen} alt="eye open" />
                  ) : (
                    <img src={EyeClosed} alt="eye closed" />
                  )
                }
              />
            </FormItem>
            <div className="d-flex justify-content-between">
              {/* TODO: Remembe me toggle & functionality */}
              {/* <p>Remember me</p> */}
              <p>
                <a
                  onClick={(e) => {
                    e.preventDefault();
                    this.handleShowModal("visibleForgot", true);
                    this.handleCancelSignIn();
                  }}
                  href="#"
                  style={{ color: colors.gencGrey }}
                >
                  Forgot your password?
                </a>
              </p>
            </div>
            <div
              className="ant-row ant-form-item"
              style={{
                textAlign: "center",
                justifyContent: "center",
                alignItems: "center",
                width: "100%",
                padding: "0.1em",
              }}
            >
              <Button
                htmlType="submit"
                type="primary"
                block
                style={{
                  border: "none",
                  backgroundColor: colors.gencRed,
                  fontWeight: "700",
                  fontSize: "20px",
                  borderRadius: "10px",
                  width: "70%",
                  height: "56px",
                }}
              >
                Sign In
              </Button>
            </div>
            <div className="text-center">
              <p style={{ color: colors.gencBlack }}>
                If you don't have an account{" "}
                <a
                  onClick={(e) => {
                    e.preventDefault();
                    this.handleShowModal("visibleSignUp", true);
                    this.handleCancelSignIn();
                  }}
                  href="#"
                  style={{ color: colors.gencRed }}
                >
                  Register now!
                </a>
              </p>
            </div>
          </Form>
        </Modal>
        <Modal
          // TODO: FIX UI MOBILE MODAL
          // title="Create your GenC Space"
          visible={visibleSignUp}
          className="modalSignInClass"
          footer={[]}
          onCancel={() => this.handleShowModal("visibleSignUp", false)}
        >
          <SignUp
            handleResgiterSuccess={() => {
              this.handleResgiterSuccess();
            }}
          />
        </Modal>
        <Modal
          // title="Forgot your password"
          visible={visibleForgot}
          className="modalSignInClass"
          footer={[]}
          onCancel={() => this.handleShowModal("visibleForgot", false)}
          style={{ color: colors.gencBlue }}
        >
          <ForgotPass
            handleForgotPassSuccess={() => {
              this.handleForgotPassSuccess();
            }}
          />
        </Modal>
      </>
    );
  }
}
const mapStateToProps = (state) => ({
  member: state.member || {},
});

const mapDispatchToProps = (dispatch) => {
  return {
    login: (data) => login(data),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LandingPageDesignMobile);
